import React, { SVGProps } from 'react';

export const ParticipantsSVG = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18 2.87282C16.3021 1.49902 14.1841 0.749512 12 0.749512C9.8159 0.749512 7.69794 1.49902 6 2.87282'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.5 6.48765C9.49059 5.68655 10.726 5.24951 12 5.24951C13.274 5.24951 14.5094 5.68655 15.5 6.48765'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.75 13.875C0.75 14.5712 1.02656 15.2389 1.51884 15.7312C2.01113 16.2234 2.67881 16.5 3.375 16.5C4.07119 16.5 4.73887 16.2234 5.23116 15.7312C5.72344 15.2389 6 14.5712 6 13.875C6 13.1788 5.72344 12.5111 5.23116 12.0188C4.73887 11.5266 4.07119 11.25 3.375 11.25C2.67881 11.25 2.01113 11.5266 1.51884 12.0188C1.02656 12.5111 0.75 13.1788 0.75 13.875V13.875Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.514 19.9828C7.24881 19.3632 6.84783 18.8111 6.34067 18.3672C5.8335 17.9233 5.23311 17.599 4.58383 17.4183C3.93454 17.2375 3.25295 17.2049 2.58938 17.3229C1.92581 17.4408 1.29721 17.7063 0.75 18.0998'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18 13.875C18 14.2197 18.0679 14.5611 18.1998 14.8795C18.3317 15.198 18.5251 15.4874 18.7688 15.7312C19.0126 15.9749 19.302 16.1683 19.6205 16.3002C19.9389 16.4321 20.2803 16.5 20.625 16.5C20.9697 16.5 21.3111 16.4321 21.6295 16.3002C21.948 16.1683 22.2374 15.9749 22.4812 15.7312C22.7249 15.4874 22.9183 15.198 23.0502 14.8795C23.1821 14.5611 23.25 14.2197 23.25 13.875C23.25 13.5303 23.1821 13.1889 23.0502 12.8705C22.9183 12.552 22.7249 12.2626 22.4812 12.0188C22.2374 11.7751 21.948 11.5817 21.6295 11.4498C21.3111 11.3179 20.9697 11.25 20.625 11.25C20.2803 11.25 19.9389 11.3179 19.6205 11.4498C19.302 11.5817 19.0126 11.7751 18.7688 12.0188C18.5251 12.2626 18.3317 12.552 18.1998 12.8705C18.0679 13.1889 18 13.5303 18 13.875V13.875Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.4858 19.9828C16.751 19.3632 17.152 18.8111 17.6592 18.3672C18.1663 17.9233 18.7667 17.599 19.416 17.4183C20.0653 17.2375 20.7469 17.2049 21.4105 17.3229C22.074 17.4408 22.7026 17.7063 23.2498 18.0998'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.625 13.125C8.625 14.0201 8.98058 14.8785 9.61351 15.5115C10.2465 16.1444 11.1049 16.5 12 16.5C12.8951 16.5 13.7535 16.1444 14.3865 15.5115C15.0194 14.8785 15.375 14.0201 15.375 13.125C15.375 12.2299 15.0194 11.3715 14.3865 10.7385C13.7535 10.1056 12.8951 9.75 12 9.75C11.1049 9.75 10.2465 10.1056 9.61351 10.7385C8.98058 11.3715 8.625 12.2299 8.625 13.125V13.125Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18 23.2496C17.8046 21.7969 17.0888 20.4643 15.9854 19.4993C14.882 18.5343 13.4659 18.0024 12 18.0024C10.5341 18.0024 9.11805 18.5343 8.01462 19.4993C6.91118 20.4643 6.19535 21.7969 6 23.2496'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
